export default __webpack_public_path__ + "48dc724ef4c14796b559b9fff9bd3b25.svg";